import React from "react";
import { Link, useNavigate } from "react-router-dom";
import StatsDisplay from "./Stats/StatsDisplay";
import EntitySwitcher from "./common/EntitySwitcher";
import { searchCompanies } from "helpers/entitySearch";
import { companyPath } from "./Company/CompanyContext";

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="main-content position-relative">
      <div className="container-fluid px-4 mb-4">
        <div className="d-flex flex-wrap align-items-center gap-3">
          <EntitySwitcher
            ariaLabel="Find a company"
            placeholder="Type a company name..."
            search={searchCompanies}
            onSelect={(option) => navigate(companyPath(option.id))}
            triggerClassName="btn btn-outline-primary"
            trigger={
              <>
                <i className="bi bi-search me-2"></i>Find a company
              </>
            }
          />
          <Link to="/companies" className="btn btn-link text-decoration-none px-0">
            View all companies<i className="bi bi-arrow-right ms-1"></i>
          </Link>
        </div>
      </div>

      <StatsDisplay />
    </div>
  );
};

export default Dashboard;
